// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"e3a1945d","334":"c8f27ead","385":"fed6576d","436":"1c66b224","546":"58d4dddd","567":"f207e0e8","608":"e30db00e","734":"62e04e92","762":"950b2e31","936":"adc267eb"}[chunkId] + ".chunk.css";
};